import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useOnboardingDashboardConfig } from '@frontend/onboarding-dashboard';
import { useScopedAppFlagStore } from '@frontend/scope';
import { createNavItem, createSubNavItems } from '../nav-item-utils';

export const useHomeNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { showOnboardingDashboard } = useOnboardingDashboardConfig();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const ourPartnersPage = getFeatureFlagValue('our-partners-page');

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          label: t('Welcome to Weave'),
          relativePath: '/onboarding',
          trackingId: 'app-nav-item-onboarding-dashboard',
          show: showOnboardingDashboard,
          description: undefined,
        },
        {
          label: t('My Dashboard'),
          relativePath: '/dashboard',
          trackingId: 'app-nav-item-dashboard',
          description: 'A personalized home page and dashboard that surfaces key insights, metrics, and quick actions.',
        },
        {
          label: t('Settings'),
          path: '#settings/organization' as any,
          trackingId: 'app-nav-item-portal',
          show: true,
          description: undefined,
        },
        {
          label: t('Our Partners'),
          relativePath: '/partners',
          show: ourPartnersPage,
          trackingId: 'app-nav-item-our-partners',
          description:
            'Showcases integrated partners, third-party services, and potential add-ons available for your account.',
        },
      ]),
    [t, showOnboardingDashboard, ourPartnersPage]
  );

  return useMemo(
    () =>
      createNavItem('home', {
        iconName: 'home',
        label: t('Home'),
        root: '/home',
        subNavItems,
        show: true,
      }),
    [t, subNavItems]
  );
};
